import React, { useEffect, useState } from 'react';
import { MemberSeatTableType, MemberTableData } from './data/MemberSeatTableData';
import { ColumnDef, ColumnFiltersState, SortingState } from '@tanstack/react-table';
import TableCheckbox from '../../../common/checkbox/TableCheckbox';
import { UserBadge } from '../Members/Members/Utils';
import Micromodal from 'micromodal';
import TanstackContent from '../Table/Tanstack/TanstackContent';
import { getExportHeaders } from '../ReportingGroup/types/tableHeaders';
// import useMemberSeatTable from './context/MemberSeatTableContext';

const ManageBillingModalTable = ({ membersData, setSeatToRenew, setSeatToAssign }) => {
    const [ columnFilters, setColumnFilters ] = useState<ColumnFiltersState>([])
    const [ rowSelection, setRowSelection ] = React.useState({})
    const [ globalFilter, setGlobalFilter ] = React.useState('')
    const [ sorting, setSorting ] = React.useState<SortingState>([])
    const [ data, setData ] = React.useState( () => MemberTableData( membersData ) )
    // const { setUseHeader } = useMemberSeatTable()

    useEffect(() => {
        Micromodal.init()
        // setUseHeader(['all'])
    }, [])

    const columns = React.useMemo<ColumnDef<MemberSeatTableType>[]>(
        () => [
          {     
            id: 'select',
            meta: {
              className: "msync-table__cell--select",
            },
            header: ({ table }) => (
              <TableCheckbox
                {...{
                  checked: table.getIsAllRowsSelected(),
                  indeterminate: table.getIsSomeRowsSelected(),
                  onChange: table.getToggleAllRowsSelectedHandler(),
                }}
              />
            ),
            cell: ({ row }) => (
              <div className="px-1">
                <TableCheckbox
                  {...{
                    checked: row.getIsSelected(),
                    disabled: !row.getCanSelect(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                  }}
                />
              </div>
            ),
          },
          {
            id: 'columns',
            columns: [
              {
                id: 'memberId',
                accessorKey: 'memberId',
                prettyName: 'Member ID',
                show: false,
                cell: info => info.getValue(),
                footer: props => props.column.id,
                header: () => <span>Member ID</span>,
              },
              {
                id: 'displayName',
                accessorKey: 'displayName',
                prettyName: 'Display Name',
                show: true,
                cell: info => info.getValue(),
                footer: props => props.column.id,
                header: () => <span>Display Name</span>,
              },
              {
                id: 'lastActivity',
                accessorKey: 'lastActivity',
                prettyName: 'Last Activity',
                show: false,
                cell: info => info.getValue(),
                footer: props => props.column.id,
                header: () => <span>Last Activity</span>,
              },
              {
                id: 'role',
                accessorKey: 'role',
                prettyName: 'Role',
                cell: (info) => (
                  <UserBadge role={ info.getValue() } />
                ),
                footer: props => props.column.id,
                header: () => <span>Role</span>,
                // filterFn: customFilterFn
              },
              {
                id: 'access',
                accessorKey: 'access',
                enableSorting: false,
                prettyName: 'Access',
                cell: (info) => {
                  let member = info.row.original
                  
                  return (
                    <div className="msync-form__row"> 
                      <div className="msync-form__col">
                        <div className="msync-form__row">
                          <div>
                            {
                              tangibleFields.render({
                                label: 'Renew',
                                type: 'switch',
                                name: 'org_plan_member_renew_' + member.memberId,
                                value: member.seatAutoRedemption,
                                readOnly: true,
                                onChange: (value) => {
                                  setSeatToRenew(member.memberId, value)
                                }
                              })
                            }
                          </div>
                          <div>
                            {
                              tangibleFields.render({
                                label: 'Seat',
                                type: 'switch',
                                name: 'org_plan_member_seat_' + member.memberId,
                                value: member.seatAssigned,
                                onChange: (value) => {
                                  setSeatToAssign(member.memberId, value)
                                }
                              })
                            }
                          </div>
                        </div>
                        <div>
                        { 
                          member.seatAssigned === 'on' ? 
                            member.expiresAt !== 0 ? <>
                              { member.seatAutoRedemption === 'on' ? 'Access will renew on ' : 'Access will expire on ' }
                              { member.expiresAt }
                            </> : 'Access will never expire'
                          : ''
                        }
                        </div>
                      </div>
                    </div>
                  )
                },
                footer: props => props.column.id,
                header: () => <span>Access</span>,
                meta: {
                  className: "msync-custom-member-action-header",
                },
              },
              {
                id: 'actions',
                accessorKey: 'actions',
                enableSorting: false,
                prettyName: 'Actions',
                cell: (info) => (
                    <div></div>
                //   <Actions info={ info.row.original } />
                ),
                footer: props => props.column.id,
                header: () => <span>Actions</span>,
                meta: {
                  className: "msync-custom-member-action-header",
                },
              },
            ]
          }
        ],
        []
      )

    const exportHeaders = getExportHeaders('team-members-seat')

    return (
        <div>
        {
            <TanstackContent
              data={ data }
              columns={ columns }
              rowSelection={ rowSelection }
              setRowSelection={ setRowSelection }
              sorting={ sorting }
              setSorting={ setSorting }
              globalFilter={ globalFilter }
              setGlobalFilter={ setGlobalFilter }
              exportHeaders={ exportHeaders }
              from='Members'
              context='MemberSeat'
              hideFilters={ true }
              columnFilters={ columnFilters }
              setColumnFilters={ setColumnFilters }
            >
              <></>
            </TanstackContent>
        }   
        </div>
    );
};

export default ManageBillingModalTable;